"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "28", height: "28", viewBox: "0 0 28 28", className: "Icon toolbar-caption", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M4 18h20v2H4zM4 22h16v2H4z" }),
            _react2.default.createElement("path", { fill: "#BBB", d: "M0 14h28v1H0z" }),
            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "27", height: "27", rx: "2.4" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-caption.js
// module id = 1878
// module chunks = 0